import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import EnableCallRecordingModal from './enable-call-recording-modal';
import { IProps } from './types';
import { bulkUpdatePhoneNumberSettingsRequest, updatePhoneNumberSettingsRequest } from '../../../../../../extra-actions';
import { PhoneNumberSettingCode } from '../../../../../../types/phone-numbers';

const EnableCallRecordingModalContainer: React.FC<IProps> = ({
  show,
  onClose,
  selectedPhoneNumbers,
  deSelectedPhoneNumbers,
  isSelectAllAcrossPages,
  phoneNumberFilters,
  searchText,
  refreshPhoneNumbers,
  handleClearSelection,
  convertFiltersToAPIFormat,
}) => {
  const dispatch = useDispatch<any>();

  const handleSubmit = useCallback(async (enabled: boolean) => {
    const selectedCount = selectedPhoneNumbers?.length || 0;
    const deSelectedCount = deSelectedPhoneNumbers?.length || 0;
    const settings = [{
      code: PhoneNumberSettingCode.CALL_RECORDING_ENABLED,
      value: enabled ? 'true' : 'false',
    }];

    try {
      if (selectedCount > 0 && deSelectedCount === 0 && selectedPhoneNumbers) {
        const phoneNumberIds = selectedPhoneNumbers.map((item) => item.id);
        await dispatch(updatePhoneNumberSettingsRequest({
          phoneNumberIds,
          settings,
        })).unwrap();
      } else if (selectedCount === 0 && deSelectedCount >= 0 && deSelectedPhoneNumbers && isSelectAllAcrossPages) {
        const deselectedPhoneNumberIds = deSelectedPhoneNumbers.map((item) => item.id);
        const apiFilters = convertFiltersToAPIFormat?.(phoneNumberFilters, searchText);
        await dispatch(bulkUpdatePhoneNumberSettingsRequest({
          ...(deselectedPhoneNumberIds.length > 0 && { deselectedPhoneNumberIds }),
          ...(apiFilters && { phoneNumberFilters: apiFilters }),
          settings,
        })).unwrap();
      }
    } catch (e) {
      // swallow error; UI can be improved with toast if needed
    }
  }, [convertFiltersToAPIFormat, deSelectedPhoneNumbers, dispatch, isSelectAllAcrossPages, phoneNumberFilters, searchText, selectedPhoneNumbers]);

  return (
    <EnableCallRecordingModal
      show={show}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
};

export default memo(EnableCallRecordingModalContainer);

